import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import { useDispatch } from "react-redux";
import { taskDetailModalToggle } from "../../redux/actions/taskDetail.action";
import { isValidUrl } from "../../utils/helperFn";
import { taskCatImg } from "../../utils/taskCatImg";
import "./TaskItem.styles.css";

const CompletedTask = ({ data, t }) => {
  const dispatch = useDispatch();
  const [isExternal, setIsExternal] = React.useState(false);

  React.useEffect(() => {
    if (
      data.taskMode === "OFFLINE" &&
      ["INTERVIEW", "GROUP_DISCUSSION"].includes(data.taskType) &&
      data?.location &&
      isValidUrl(data.location)
    )
      setIsExternal(true);
  }, []);

  const handleModal = () => {
    dispatch(taskDetailModalToggle(data));
  };

  const loadButton = () => {
    if (data.taskStatus === "COMPLETED") {
      return (
        <button
          title={t("completed")}
          className="btn cm-trans-btn cm-task-btn cm-task-complete-btn cm-locked-btn fw-medium cm-sm-txt cm-truncate-1"
          style={{ width: "calc(100% - 48px)" }}
        >
          {t("completed")}
        </button>
      );
    }
    if (
      ["INTERVIEW", "GROUP_DISCUSSION"].includes(data.taskType) &&
      (data.taskStatus === "NOT_CONDUCTED" ||
        (!data.taskStartDate && data.taskStatus === "EXPIRED"))
    ) {
      return (
        <button
          title={t("not_conducted")}
          className="btn cm-trans-btn cm-task-btn cm-locked-btn fw-medium cm-sm-txt cm-truncate-1"
          style={{ width: "calc(100% - 48px)" }}
        >
          {t("not_conducted")}
        </button>
      );
    }

    return (
      <button
        title={t("did_not_partake")}
        className="btn cm-trans-btn cm-task-btn cm-locked-btn fw-medium cm-sm-txt cm-truncate-1"
        style={{ width: "calc(100% - 48px)" }}
      >
        {t("did_not_partake")}
      </button>
    );
  };

  const loadTaskCat = () => {
    if (data.taskType === "HOGAN_ASSESSMENTS") {
      return t("hogan_candidate_tasktype");
    }
    if (data.taskType === "FEEDBACK_SURVEY") {
      if (!!data?.modeType && data?.modeType !== "FEEDBACK_SURVEY") {
        return t(data.modeType.toLowerCase());
      }
      return t("360_survey");
    }
    if (data.taskMode === null)
      return data.taskType === "ASSESSMENT"
        ? t("test")
        : data.taskType === "BTA" ? t("business_thinking_appraisal") : t(data.taskType.toLowerCase());
    if (["online", "offline", "ai"].includes(data.taskMode?.toLowerCase())) {
      if (!!data?.modeType) {
        return ["ASSESSMENT", "TESTS"].includes(data?.modeType)
          ? t("test")
          : data.taskType === "BTA" ? t("business_thinking_appraisal") :  t(data.modeType.toLowerCase());
      } else {
        return ["ASSESSMENT", "TESTS"].includes(data?.taskType)
          ? t("test")
          : data.taskType === "BTA" ? t("business_thinking_appraisal") : t(data.taskType?.toLowerCase());
      }
    }
  };

  const handleBgImage = () => {
    if(data.taskMode === "AI") {
      return taskCatImg("ai_led_session");
    }
    if (data.taskType === "TTE_ASSESSMENTS") {
      return taskCatImg(data.originalTaskName);
    }
    if (data.taskType === "HOGAN_ASSESSMENTS") {
      switch (data.originalTaskName) {
        case "hogan_personality_inventory":
          return taskCatImg("hogan_hpi");
        case "hogan_development_survey":
          return taskCatImg("hogan_hds");
        case "motives_values_preferences_inventory":
          return taskCatImg("hogan_mvpi");
        default:
          return taskCatImg("hogan_hbri");
      }
    }
    if (data.taskType === "FEEDBACK_SURVEY") {
      if (!!data?.modeType) {
        return taskCatImg(data.modeType);
      }
    }

    // FOR INTERVIEW GD AND TESTS
    return taskCatImg(
      data.taskMode === null
        ? data.taskType
        : !!data.modeType
        ? data.modeType
        : ""
    );
  };

  const showDurationHandler = () => {
    let label = "";
    let icon = regular("clock");
    if (data.taskControl === "LOCK" || data.block) {
      label = "--";
    } else if (
      data.taskType === "ASSESSMENT" ||
      "FEEDBACK_SURVEY" ||
      "HOGAN_ASSESSMENTS"
    ) {
      if (![null, 35791394, 0].includes(data.duration)) {
        label = `${data.duration} ${t("mins")}`;
      } else {
        icon = regular("hourglass-clock");
        label = t("candidate_side_deadline_based");
      }
    } else if (data?.duration) {
      label = `${data.duration} ${t("mins")}`;
    } else {
      label = "--";
    }
    return (
      <div className="d-flex ms-3">
        <FontAwesomeIcon
          icon={icon}
          className="text-blue-gray-500 cm-xs-txt me-6 my-auto"
        />
        <p className="cm-task-title text-blue-gray-700 my-0 fw-medium cm-xs-txt my-auto">
          {label}
        </p>
      </div>
    );
  };

  return (
    <div className="cm-task-item d-flex flex-column justify-content-between col-3">
      <div className="cm-task-item-content">
        <div className="cm-task-item-img position-relative">
          <img
            src={handleBgImage()}
            alt={data.taskName}
            className="img-fluid cm-bw-img"
          />
          {data.taskMode === "OFFLINE" && (
            <span className="cm-offline-badge bg-blue-gray-700 border border-white position-absolute text-uppercase text-white cm-xs-txt fw-medium">
              {isExternal ? t("external") : t("offline_candidate")}
            </span>
          )}
        </div>
        <p
          className="cm-task-title fw-semibold my-0 cm-fs-16 cm-truncate-1 px-3 pt-3 pb-2 cm-sm-txt"
          title={t(data.taskName)}
        >
          {t(data.taskName)}
        </p>
        <p className="cm-sm-txt cm-task-category my-0 text-blue-gray-500 px-3">
          {loadTaskCat()}
        </p>
        <hr className="my-12 mx-3" />
        <p className="ms-3 mb-10 d-inline-block my-0 cm-sm-txt text-blue-gray-500">
          {t("deadline")} :{" "}
          <span className="text-blue-gray-700 fw-semibold">
            {data.taskEndDate ? moment(data.taskEndDate).format("MMM DD YYYY @ hh:mm A") : "--"}
          </span>
        </p>
      </div>
      {showDurationHandler()}
      <div className="cm-task-actions d-flex">
        {loadButton()}
        <button
          className="btn cm-trans-btn cm-task-icon-btn cm-sm-txt"
          onClick={handleModal}
        >
          <FontAwesomeIcon
            icon={regular("memo-circle-info")}
            className="text-blue-gray-700"
          />
        </button>
      </div>
    </div>
  );
};

export default CompletedTask;
